import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement, userManagementBaseUrl } from '../endpoints';
// Define a service using a base URL and expected endpoints
export const organizationMasterService = createApi({
    reducerPath: 'organizationMasterService',
    baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
    tagTypes: ['Organization'],
    endpoints: (builder) => ({
        getAllOrganizationMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.organizationMasterController.getAllOrganizationMaster}/${body.payload.page}/${body.payload.size}?orderBy=${body.payload.orderBy}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        getOrganizationMasterById: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.organizationMasterController.getOrganizationMasterById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        saveOrganizationMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.organizationMasterController.saveOrganizationMaster}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        updateOrganizationMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.organizationMasterController.updateOrganizationMaster}/${body.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        deleteOrganizationMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.organizationMasterController.deleteOrganizationMaster}/${body.id}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        getAllOrganizationMasterBySearch: builder.mutation({
            query(body) {
                console.log(body, "body");

                return {
                    url: `${userManagement.organizationMasterController.getAllOrganizationMasterBySearch}`,
                    method: "POST",
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                };
            },
        }),
        findAllOrganizationMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.organizationMasterController.findAllOrganizationMaster}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        bulkSaveOrganizationMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.organizationMasterController.bulkSaveOrganizationMaster}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
    })
});
export const {
    useGetAllOrganizationMasterMutation,
    useGetOrganizationMasterByIdMutation,
    useSaveOrganizationMasterMutation,
    useUpdateOrganizationMasterMutation,
    useDeleteOrganizationMasterMutation,
    useGetAllOrganizationMasterBySearchMutation,
    useFindAllOrganizationMasterMutation,
    useBulkSaveOrganizationMasterMutation,
} = organizationMasterService;